/*
  LIOR - "text with icons" in the style of iOS 27 (sections/text-with-icon.liquid,
  styles in assets/lior-ios-icons-row.css)

    - the tiles rise in as they come on screen, a few at a time
    - each symbol plays a small SF Symbols-style effect once when its tile arrives,
      and again when the tile is touched or hovered (bounce, wiggle, drive, spin,
      beat, ring, pulse; chosen per icon in the Liquid)
    - on phones, the page dots under the sideways row follow the scroll
  Nothing moves under prefers-reduced-motion, and the section reads in full
  without this file. Several sections can share it; it mounts each one once.
*/
(function () {
  'use strict';

  var W = window;
  var D = document;
  if (W.__liorIosIcons) {
    W.__liorIosIcons();
    return;
  }

  var mqReduce = W.matchMedia('(prefers-reduced-motion: reduce)');
  var RTL = (D.documentElement.getAttribute('dir') || 'rtl').toLowerCase() === 'rtl';
  var F = RTL ? -1 : 1;
  /* damping 0.6, response 0.38: lively, for the symbols only */
  var BOUNCY = 'linear(0, 0.055, 0.184, 0.3573, 0.5295, 0.6888, 0.824, 0.9301, 1.0096, 1.058, 1.084, 1.0929, 1.0896, 1.0785, 1.0628, 1.0468, 1.0316, 1.0186, 1.0082, 1.0002, 0.9953, 0.9925, 0.9914, 0.9915, 0.9925, 0.9939, 0.9954, 0.9968, 0.9981, 0.9991, 0.9999, 1.0004, 1)';
  var HAS_LINEAR = !!(W.CSS && CSS.supports && CSS.supports('transition-timing-function', 'linear(0, 1)'));
  var EASE_IO = 'cubic-bezier(0.45, 0, 0.25, 1)';

  function reduce() { return mqReduce.matches; }

  /* SF Symbols-style effects, as transform keyframes (they add to the glyph's own flip) */
  var FX = {
    bounce: {
      duration: 760,
      easing: EASE_IO,
      frames: [
        { transform: 'translateY(0) scale(1)' },
        { transform: 'translateY(1px) scale(0.84, 0.8)', offset: 0.2 },
        { transform: 'translateY(-3px) scale(1.1, 1.12)', offset: 0.48 },
        { transform: 'translateY(0.5px) scale(0.97)', offset: 0.74 },
        { transform: 'translateY(0) scale(1)' }
      ]
    },
    wiggle: {
      duration: 820,
      easing: EASE_IO,
      frames: [
        { transform: 'rotate(0deg)' },
        { transform: 'rotate(-13deg)', offset: 0.16 },
        { transform: 'rotate(11deg)', offset: 0.36 },
        { transform: 'rotate(-7deg)', offset: 0.56 },
        { transform: 'rotate(3deg)', offset: 0.76 },
        { transform: 'rotate(0deg)' }
      ]
    },
    drive: {
      duration: 860,
      easing: EASE_IO,
      frames: [
        { transform: 'translateX(0) rotate(0deg)' },
        { transform: 'translateX(' + (-2.5 * F) + 'px) rotate(' + (2 * F) + 'deg)', offset: 0.18 },
        { transform: 'translateX(' + (5 * F) + 'px) rotate(' + (-1.5 * F) + 'deg)', offset: 0.46 },
        { transform: 'translateX(' + (-1.5 * F) + 'px) rotate(0deg)', offset: 0.72 },
        { transform: 'translateX(0) rotate(0deg)' }
      ]
    },
    spin: {
      duration: 900,
      easing: HAS_LINEAR ? BOUNCY : 'cubic-bezier(0.34, 1.36, 0.64, 1)',
      frames: [
        { transform: 'rotate(0deg)' },
        { transform: 'rotate(-360deg)' }
      ]
    },
    beat: {
      duration: 880,
      easing: EASE_IO,
      frames: [
        { transform: 'scale(1)' },
        { transform: 'scale(1.18)', offset: 0.16 },
        { transform: 'scale(0.96)', offset: 0.32 },
        { transform: 'scale(1.1)', offset: 0.48 },
        { transform: 'scale(1)' }
      ]
    },
    ring: {
      duration: 900,
      easing: EASE_IO,
      frames: [
        { transform: 'rotate(0deg)' },
        { transform: 'rotate(16deg)', offset: 0.14 },
        { transform: 'rotate(-14deg)', offset: 0.3 },
        { transform: 'rotate(10deg)', offset: 0.46 },
        { transform: 'rotate(-6deg)', offset: 0.62 },
        { transform: 'rotate(2deg)', offset: 0.8 },
        { transform: 'rotate(0deg)' }
      ]
    },
    pulse: {
      duration: 1000,
      easing: EASE_IO,
      frames: [
        { opacity: 1, transform: 'scale(1)' },
        { opacity: 0.35, transform: 'scale(0.9)', offset: 0.45 },
        { opacity: 1, transform: 'scale(1)' }
      ]
    }
  };

  function play(item) {
    if (reduce()) return;
    var g = item.querySelector('.lii-g, .lii-img');
    if (!g || !g.animate) return;
    var t = Date.now();
    if (item.__liiT && t - item.__liiT < 500) return;
    item.__liiT = t;
    var fx = FX[item.getAttribute('data-lii-fx')] || FX.bounce;
    if (item.__liiA) item.__liiA.cancel();
    item.__liiA = g.animate(fx.frames, { duration: fx.duration, easing: fx.easing });
  }

  function mount(root) {
    if (root.__lii) return;
    root.__lii = true;
    var items = Array.prototype.slice.call(root.querySelectorAll('.lii-item'));
    if (!items.length) return;

    /* ---------------- Arrival ----------------
       A grid: each tile when it comes on screen. A sideways row on a phone: the whole
       row at once, so swiping shows tiles that are already there. Each symbol plays its
       effect the first time its tile is really in view (after it has risen in). */
    root.classList.add('lii-js');
    var rowEl = root.querySelector('[data-lii-row]');
    function isRow() {
      return !!rowEl && W.getComputedStyle(rowEl).display === 'flex';
    }
    function arrive(list) {
      list.sort(function (a, b) {
        var ra = a.getBoundingClientRect();
        var rb = b.getBoundingClientRect();
        return Math.round(ra.top - rb.top) || (RTL ? rb.left - ra.left : ra.left - rb.left);
      });
      var t = Date.now();
      list.forEach(function (it, i) {
        if (it.classList.contains('is-in')) return;
        var d = reduce() ? 0 : Math.min(i, 5) * 80;
        it.__liiReady = t + d + 380;
        it.style.setProperty('--lii-d', d + 'ms');
        it.classList.add('is-in');
        setTimeout(function () { it.style.removeProperty('--lii-d'); }, d + 1200);
        if (it.__liiSeen) setTimeout(function () { play(it); }, d + 380);
      });
    }
    function seen(it) {
      if (it.__liiSeen) return;
      it.__liiSeen = true;
      if (!it.classList.contains('is-in')) return;
      setTimeout(function () { play(it); }, Math.max(0, (it.__liiReady || 0) - Date.now()));
    }
    if ('IntersectionObserver' in W) {
      var io = new IntersectionObserver(function (entries) {
        var list = [];
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          if (e.target === rowEl) {
            items.forEach(function (it) { list.push(it); });
            io.unobserve(rowEl);
            items.forEach(function (it) { io.unobserve(it); });
          } else {
            list.push(e.target);
            io.unobserve(e.target);
          }
        });
        if (list.length) arrive(list);
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.2 });
      if (isRow()) io.observe(rowEl);
      else items.forEach(function (it) { io.observe(it); });
      var fxIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            seen(e.target);
            fxIO.unobserve(e.target);
          }
        });
      }, { threshold: 0.6 });
      items.forEach(function (it) { fxIO.observe(it); });
    } else {
      items.forEach(function (it) { it.__liiSeen = true; });
      arrive(items);
    }

    /* the theme editor: a selected block comes into view */
    D.addEventListener('shopify:block:select', function (e) {
      var it = e.target && e.target.closest && e.target.closest('.lii-item');
      if (!it || !root.contains(it)) return;
      arrive([it]);
      if (isRow()) it.scrollIntoView({ block: 'nearest', inline: 'start', behavior: reduce() ? 'auto' : 'smooth' });
    });

    /* ---------------- Touch and hover replay the effect ---------------- */
    root.addEventListener('pointerdown', function (e) {
      var it = e.target.closest && e.target.closest('.lii-item');
      if (it && it.classList.contains('is-in')) play(it);
    });
    root.addEventListener('pointerover', function (e) {
      if (e.pointerType !== 'mouse') return;
      var it = e.target.closest && e.target.closest('.lii-item');
      if (!it || !it.classList.contains('is-in')) return;
      if (e.relatedTarget && it.contains(e.relatedTarget)) return;
      play(it);
    });

    /* ---------------- Page dots on the sideways row ---------------- */
    var row = root.querySelector('[data-lii-row]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('.lii-dot'));
    if (row && dots.length) {
      var raf = 0;
      var cur = 0;
      var paint = function () {
        raf = 0;
        var max = row.scrollWidth - row.clientWidth;
        var x = Math.abs(row.scrollLeft);
        var n = dots.length;
        var i = max > 0 ? Math.round((x / max) * (n - 1)) : 0;
        if (i === cur) return;
        dots[cur].classList.remove('is-on');
        dots[i].classList.add('is-on');
        cur = i;
      };
      var gutter = function () {
        var g = parseFloat(W.getComputedStyle(row).paddingRight) || 0;
        if (g > 0) row.style.setProperty('--lii-gutter', g.toFixed(1) + 'px');
      };
      row.addEventListener('scroll', function () {
        if (!raf) raf = W.requestAnimationFrame(paint);
      }, { passive: true });
      gutter();
      var rt = 0;
      W.addEventListener('resize', function () {
        clearTimeout(rt);
        rt = setTimeout(function () {
          if (!row.isConnected) return;
          gutter();
          paint();
        }, 150);
      });
    }
  }

  function scan() {
    var roots = D.querySelectorAll('[data-lii]');
    for (var i = 0; i < roots.length; i++) mount(roots[i]);
  }
  W.__liorIosIcons = scan;

  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  D.addEventListener('shopify:section:load', scan);
})();
